import { Search, Bell, UserPlus } from 'lucide-react';

interface DashboardStatsProps {
  totalSearches: number;
  activeAlerts: number;
  totalLeads: number;
  newLeads: number;
}

export function DashboardStats({ totalSearches, activeAlerts, totalLeads, newLeads }: DashboardStatsProps) {
  const stats = [
    { label: 'Ricerche', value: totalSearches, icon: Search, color: 'text-blue-600' },
    { label: 'Alert', value: activeAlerts, icon: Bell, color: 'text-green-600' },
    { label: 'Lead', value: totalLeads, sub: newLeads > 0 ? `+${newLeads}` : undefined, icon: UserPlus, color: 'text-purple-600' },
  ];

  return (
    <div className="flex gap-4">
      {stats.map((stat) => (
        <div key={stat.label} className="flex items-center gap-2">
          <stat.icon className={`h-4 w-4 ${stat.color}`} />
          <span className="text-sm font-semibold text-gray-900">{stat.value}</span>
          <span className="text-xs text-gray-400">{stat.label}</span>
          {stat.sub && (
            <span className="text-xs text-green-600 font-medium">{stat.sub}</span>
          )}
        </div>
      ))}
    </div>
  );
}
